import { render, staticRenderFns } from "./MobileNavigation.vue?vue&type=template&id=10ed2362&scoped=true&lang=pug&"
import script from "./MobileNavigation.vue?vue&type=script&lang=js&"
export * from "./MobileNavigation.vue?vue&type=script&lang=js&"
import style0 from "./MobileNavigation.vue?vue&type=style&index=0&id=10ed2362&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ed2362",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
